import React from 'react';
import { VERDICTS, usd, num, sessionTag, mt5Time } from './v4Format';

const HEADERS = ['Time (MT5)', 'Entry', 'Pair', 'Ship Dir', 'Session', 'Tide', 'Verdict', 'TP move', 'Drawdown', 'Max excursion', 'Result'];
const td = { padding: '0.45rem 0.6rem', whiteSpace: 'nowrap' };

const V4Row = ({ f, i }) => {
  const sess = sessionTag(f.timestamp);
  const flipped = !!f.v2_confirm_active;
  const dir = flipped ? f.v2_confirm_direction : f.direction;
  const high = !!f.tide_v4_high;
  const vinfo = VERDICTS[f.verdict] || { emoji: f.status === 'FINALIZED' ? '•' : '⏳', label: f.verdict || (f.status === 'FINALIZED' ? '—' : 'Tracking'), color: '#64748b' };
  const res = f.result === 'win' ? '✅' : f.result === 'miss' ? '❌' : '⏳';
  return (
    <tr data-testid={`user-v4-row-${i}`} style={{ borderBottom: '1px solid #f1f5f9', background: high ? '#f0fdf4' : undefined }}>
      <td style={{ ...td, color: '#64748b' }}>{mt5Time(f.timestamp)}</td>
      <td style={{ ...td, fontVariantNumeric: 'tabular-nums' }}>{f.entry_price != null ? Number(f.entry_price).toFixed((f.pair || '').includes('JPY') ? 3 : 5) : '—'}</td>
      <td style={{ ...td, fontWeight: 700 }}>{f.skull_v4 && <span data-testid={`user-v4-skull-${i}`} title="💀 Bad conditions when this trade fired" style={{ marginRight: 4 }}>💀</span>}{f.pair}</td>
      <td style={{ ...td, fontWeight: 700, color: dir === 'BUY' ? '#16a34a' : '#dc2626' }}>{dir}{flipped && <span style={{ marginLeft: 5 }}>🔄</span>}</td>
      <td style={{ ...td, fontWeight: 600, color: sess.color }}>{sess.emoji} {sess.label}</td>
      <td data-testid={`user-v4-tide-${i}`} style={{ ...td, fontWeight: 800, color: high ? '#16a34a' : '#94a3b8' }}>
        {high ? '🌊 ' : '· '}{f.tide_v4_score != null ? f.tide_v4_score : '—'}{f.tide_v4_bloc ? <span style={{ fontWeight: 600 }}> {f.tide_v4_bloc}</span> : ''}
      </td>
      <td style={{ ...td, color: vinfo.color, fontWeight: 700 }}>{vinfo.emoji} {vinfo.label}</td>
      <td data-testid={`user-v4-tpmove-${i}`} style={{ ...td, color: '#0d9488' }}>{usd(f.tp_move_usd)} <span style={{ color: '#94a3b8' }}>({num(f.tp_move_pips)}p)</span></td>
      <td data-testid={`user-v4-drawdown-${i}`} style={{ ...td, color: '#dc2626' }}>{usd(f.drawdown_usd)} <span style={{ color: '#94a3b8' }}>({num(f.drawdown_pips)}p)</span></td>
      <td data-testid={`user-v4-maxexc-${i}`} style={td}>{usd(f.max_excursion_usd)} <span style={{ color: '#94a3b8' }}>({f.max_excursion_dir === 'ADVERSE' ? '↓' : '↑'})</span></td>
      <td data-testid={`user-v4-result-${i}`} style={{ ...td, fontWeight: 800, textAlign: 'center' }}>{res}</td>
    </tr>
  );
};

export const V4Table = ({ fires }) => (
  <div style={{ overflowX: 'auto' }}>
    <table data-testid="user-v4-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
      <thead>
        <tr style={{ background: '#f1f5f9', textAlign: 'left' }}>
          {HEADERS.map((h) => <th key={h} style={{ padding: '0.5rem 0.6rem', borderBottom: '2px solid #e2e8f0', whiteSpace: 'nowrap', color: '#334155' }}>{h}</th>)}
        </tr>
      </thead>
      <tbody>{fires.map((f, i) => <V4Row key={f.lab_id || i} f={f} i={i} />)}</tbody>
    </table>
  </div>
);
